import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { MessengerChat } from 'react-messenger-chat-plugin';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Styles/core.css';
import { baseName } from './Constants/Global';
import favicon from './Medias/LogosPT/favicon.png';
import SiteHelmet from './Components/SiteHelmet';
import MainMenu from './Components/MainMenu';
import MainFooter from './Components/MainFooter';
import Home from './Pages/Home';
import Article from './Pages/Article';
import ArticleView from './Pages/ArticleView';
import OurFirm from './Pages/OurFirm';
import OurTeam from './Pages/OurTeam';
import Service from './Pages/Service';
import Publication from './Pages/Publication';
import NewsAndEvents from './Pages/NewsAndEvents';
import Regulatory from './Pages/Regulatory';
import Educational from './Pages/Educational';
import Network from './Pages/Network';
import Contact from './Pages/Contact';
import ObjRouteManager from './Components/ObjRouteManager';
import ScrollToTop from './Components/ScrollToTop';
import About from './Pages/About';
import OurClient from './Pages/OurClient';
import LegalNotice from './Pages/LegalNotice';
import Disclaimer from './Pages/Disclaimer';
import Testimonial from './Pages/Testimonial';
import Client from './Pages/Client';
import EnergyLawCenter from './Pages/EnergyLawCenter';
import EnergyLawInThailand from './Pages/EnergyLawInThailand';
import MainCopyright from './Components/MainCopyright';

const App = () => {
  const [datas, setDatas] = useState({});

  const routeChangeHandler = (contents) => {
    console.log('routeChangeHandler', contents);
    setDatas(contents);
  }

  return (
    <>
      <BrowserRouter basename={baseName}>
        <ObjRouteManager changeHandler={routeChangeHandler}></ObjRouteManager>
        <ScrollToTop>
          <SiteHelmet favicon={favicon} author="PT Associate" title={datas.title} />
          <MainMenu contents={datas} />
          <Container fluid className='px-0'>
            <Routes>
              <Route path="/" element={<Home contents={datas} />} />
              <Route path="/Article" element={<Article contents={datas} />} />
              <Route path="/Article/:slug" element={<ArticleView contents={datas} />} />
              <Route path="/About" element={<About contents={datas} />} />
              <Route path="/OurFirm" element={<OurFirm contents={datas} />} />
              <Route path="/OurTeam" element={<OurTeam contents={datas} />} />
              <Route path="/OurClient" element={<OurClient contents={datas} />} />
              <Route path="/Service" element={<Service contents={datas} />} />
              <Route path="/Publication" element={<Publication contents={datas} />} />
              <Route path="/NewsAndEvents" element={<NewsAndEvents contents={datas} />} />
              <Route path="/Regulatory" element={<Regulatory contents={datas} />} />
              <Route path="/EnergyTrend" element={<Educational contents={datas} />} />
              <Route path="/Network" element={<Network contents={datas} />} />
              <Route path="/Contact" element={<Contact contents={datas} />} />
              <Route path="/LegalNotice" element={<LegalNotice contents={datas} />} />
              <Route path="/Disclaimer" element={<Disclaimer contents={datas} />} />
              <Route path="/Testimonial" element={<Testimonial contents={datas} />} />
              <Route path="/Client" element={<Client contents={datas} />} />
              {/* <Route path="/EnergyLawCenter" element={<EnergyLawCenter contents={datas} />} /> */}
              <Route path="/EnergyLawInThailand" element={<EnergyLawInThailand contents={datas} />} />
            </Routes>
          </Container>
          <MainCopyright contents={datas} />
        </ScrollToTop>
      </BrowserRouter>
    </>
  )
}

export default App